<template>
  <div class="section-title" :data-anchor="getTitleInfo(type).value">
    <p>{{getTitleInfo(type).label}}</p>
    <slot name="right"></slot>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import { anchorData } from './utils'
export default {
  name: 'event-detail-title',
  props: {
    type: VueTypes.string.isRequired
  },
  data () {
    return {
      anchorData
    }
  },
  methods: {
    getTitleInfo: function (key) {
      const info = anchorData.find(ele => ele.value === key)
      return info || {}
    }
  }
}
</script>

<style lang="scss" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(215, 179, 117, .8);

  p {
    height: 22px;
    line-height: 22px;
    font-size: 22px; font-weight: 600; color: #353535;
  }

}
</style>
